"use client";

import { HorizontalGrid, ListContainer, ListItem } from "@/components/list/dynamic-list";
import { TUser } from "@/types/types";

type UserEnrolledCoursesListProps = {
  user: TUser;
};

export default function UserEnrolledCoursesList({ user }: UserEnrolledCoursesListProps) {
  return (
    <>
      <ListContainer
        title="Enrolled courses"
        variant="transparent"
        isEmpty={user.enrollments.length === 0}
        emptyMessage="No courses yet"
      >
        <HorizontalGrid
          items={user.enrollments}
          renderItem={(enrollment) => (
            <ListItem
              title={enrollment.course.title}
              subtitle={enrollment.course.subtitle || ""}
              thumbnailUrl={enrollment.course.thumbnailImage?.url || ""}
              href={`/course/${enrollment.course.slug}`}
              variant="grid"
            />
          )}
        />
      </ListContainer>
    </>
  );
}
